import { render } from "./ContractView.vue?vue&type=template&id=236c3c4f&scoped=true"
import script from "./ContractView.vue?vue&type=script&lang=js"
export * from "./ContractView.vue?vue&type=script&lang=js"

import "./ContractView.vue?vue&type=style&index=0&id=236c3c4f&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c3c4f"]])

export default __exports__